import type { Heartbeat } from "@shared/types";
import { cn, formatLatency } from "@/lib/utils";

type BeatLike = Pick<Heartbeat, "status" | "checkedAt" | "latencyMs" | "message">;

const BAR_BY_STATUS: Record<string, string> = {
  "0": "bg-status-down",
  "1": "bg-status-up",
  "2": "bg-status-pending",
  "3": "bg-status-maintenance",
};

/**
 * Uptime Kuma-style heartbeat bars. `beats` must be OLDEST FIRST; the row is
 * right-aligned and left-padded with placeholder bars up to `slots`.
 */
export function UptimeBars({
  beats,
  slots = 40,
  className,
}: {
  beats: BeatLike[];
  slots?: number;
  className?: string;
}) {
  const shown = beats.slice(-slots);
  const padding = Math.max(0, slots - shown.length);

  return (
    <div className={cn("flex h-6 items-stretch gap-[2px]", className)}>
      {Array.from({ length: padding }, (_, i) => (
        <span key={`pad-${i}`} className="flex-1 rounded-[2px] bg-muted" />
      ))}
      {shown.map((beat, i) => (
        <span
          key={`${beat.checkedAt}-${i}`}
          title={`${new Date(beat.checkedAt).toLocaleString()}${
            beat.latencyMs != null ? ` · ${formatLatency(beat.latencyMs)}` : ""
          }${beat.message ? ` · ${beat.message}` : ""}`}
          className={cn(
            "flex-1 rounded-[2px] transition-transform hover:scale-y-110",
            BAR_BY_STATUS[String(beat.status)] ?? "bg-muted",
          )}
        />
      ))}
    </div>
  );
}
